import { createContext, useContext } from 'react';

const DEFAULT = {
  isEven: false,
};

export const RowContext = createContext(DEFAULT);

export const ParentRowContext = createContext<typeof DEFAULT | null>(null);

export function useRowContext(useParent: true): null | typeof DEFAULT;
export function useRowContext(useParent?: false): typeof DEFAULT;
export function useRowContext(useParent?: boolean) {
  const parent = useContext(ParentRowContext);
  const current = useContext(RowContext);
  return useParent ? parent : current;
}
